import MainLayout from "@/components/layout/MainLayout.vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import axios from "axios";
import { mapGetters } from "vuex";
import moment from 'moment';
import { maxLength } from "vuelidate/lib/validators";
import { required } from 'vuelidate/lib/validators';
import ClassSessionService from "@/services/class-session/ClassSessionService";

export default {
    name: "classSessionEdit",

    components: {
        MainLayout,
        DatePicker,
    },

    data() {
        return {
            sessionData: {
              "class_session_id": '',
              "class_id": '',
              "session_date": "",
              "start_time": "",
              "end_time": "",
              "topic": "",
              "insert_time": "",
              "update_id": "",
              "update_time": "",
              "dayName": ""
            },
            classData: {
              start_date: null,
              end_date: null
            },
            submitted: false,
            time_invalid_error: false,
            time_equal_error: false,
            date_invalid_error: false,
            timePickerOptions: {
                start: "00:00",
                step: "00:15",
                end: "23:45"
            },
            disabledBtn:false
        };
    },
    validations: {
        sessionData: {
          session_date: { required },
          start_time: { required },
          end_time: {
            required
           },
          topic: {maxLength: maxLength(255)}
        }
    },

    computed: {
        ...mapGetters(["userType"]),
    },

    methods: {
        dateCheck() {
          const result = ClassSessionService.dateCheck(
                      this.sessionData.session_date,
                      this.classData.start_date,
                      this.classData.end_date
                    );
          this.date_invalid_error = result.date_invalid_error;
        },

        timeCheck() {
          const result = ClassSessionService.timeCheck(
                      this.sessionData.start_time,
                      this.sessionData.end_time
                    );
          this.time_invalid_error = result.time_invalid_error;
          this.time_equal_error = result.time_equal_error;
        },

        getClassSessionDetail() {
          axios.get(`class/session/${this.$route.params.class_id}/info/${this.$route.params.id}`)
          .then((res) => {
            this.sessionData = res.data;
            this.sessionData.start_time = this.customFormatter(res.data.start_time)
            this.sessionData.end_time = this.customFormatter(res.data.end_time)
          }).catch((error) => {
            if (error.response.status == 404) {
              this.$router.push({ name: 'notFound'
              });
            }
            console.log(error)
          })
        },

        async getClassInfo() {
          const info = await ClassSessionService.getClassInfo(this.$route.params.class_id)
          if (info) {
            this.classData.start_date = info.start_date;
            this.classData.end_date = info.end_date;
          }
        },

        customFormatter(time) {
          if (!time) return "";
          return moment(time, "HH:mm:ss").format('HH:mm');
        },

        submit() {
          this.dateCheck();
          this.timeCheck();

          this.submitted = true;
          if (
            this.date_invalid_error ||
            this.time_invalid_error ||
            this.time_equal_error ||
            this.$v.sessionData.$invalid
          ) {
            return;
          }
          this.updateClassSession()
        },

        updateClassSession() {
          this.disabledBtn = true;
          const request =
          {
            session_date: this.sessionData.session_date,
            start_time: this.sessionData.start_time,
            end_time: this.sessionData.end_time,
            topic: this.sessionData.topic,
            class_id: this.sessionData.class_id,
            class_session_id: this.sessionData.class_session_id
          };
          axios.put("class/session/" + this.$route.params.id , request)
          .then(() => {
            this.$router.push({ name: "classSession", params: { id: this.sessionData.class_id } });
            this.$notification.success("လုပ်ဆောင်မှု အောင်မြင်ပါသည်။", { timer: 3, position: "bottomCenter"
            });
          })
          .catch((err) => {
            if (err.response.status == 422) {
              this.disabledBtn = false;
              const errors = err.response.data.errors;
              if (errors.duplicate_time) {
                this.$notification.error(
                  "ဤအချိန်အပိုင်းအခြားနှင့်အတူ အခြားအတန်းချိန်တစ်ခု ရှိနေပါသည်။",
                  { timer: 3, position: "bottomCenter" }
                );
              } 
            }
            console.log(err)
          })
        },
    },

    mounted() {
      this.getClassSessionDetail()
      this.getClassInfo()
    }
};
